import * as types from '../../../../system/types'

export interface ValorTiieActualState {
    id: string,
    // errors: [],
    inProgress: boolean,
    data: number | null,
    message?: string | null
}

const ValorTiieActualInitialState: ValorTiieActualState = {
    id: '',
    // errors: [],
    data: null,
    inProgress: false
};

export default function valorTiieActualReducer(
    state: ValorTiieActualState = ValorTiieActualInitialState,
    action: types.RootAction
): ValorTiieActualState {
    switch (action.type) {
        case types.VALORTIIEACTUAL_REQUEST:
            return {
                ...state,
                message: '',
                inProgress: true
            }
        case types.VALORTIIEACTUAL_RESPONSE:
            return {
                ...state,
                data: action.data,
                message: action.message,
                inProgress: false
            }
        case types.VALORTIIEACTUAL_FAILED:
            return {
                ...state,
                message: action.message,
                inProgress: false
            }
        default:
            return state;
    }
}